<template>
  <div>
    <header-nav :cur="3"/>
    <!-- 搜索 -->
    <div class="nav">
      <div class="navtab">
       <span class="top">
            <span @click="toIndex()" style="cursor:pointer"  >首页</span>&nbsp;>
            <span class="infor">名师</span>
       </span>
        <div class="newbox">
          <div>
            <div class="newtop">学校名师</div>
            <div class="newbot">名师执教，更快速的成长</div>
          </div>
          <div class="input">
            <input placeholder="请输入您想要寻找的教师的姓名" type="text"   v-model="queryParams.teacherName"/>
            <div class="select"  @click="getList()">搜索</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 优秀讲师 -->
    <div class="navtab" style="padding-top: 50px;">
      <div class="teacher">
		<div class="wd_cont" v-if="teachers === null">
		    <img src="../../assets/img/question/ts_iconn.svg"/>
		    <p>暂无教师数据,正在更新中...</p>
		</div>
        <div class="box" v-for="(teach, index) in teachers" :key="index" else-if="teachers != null">
          <div class="teachhead" :title="teach.introduction">
            <span><img :src="$api.static_url+teach.teacherImage" alt=""/></span>
          </div>
          <div class="teachright">
            <div class="namebox">
              <span class="name">{{ teach.teacherName }}</span>
              <span class="detal" :title="teach.introduction">{{ teach.introduction}}</span>
            </div>
            <div class="listbox">
              <div>
                <div class="div"></div>
                <div class="list">
                  {{ teach.academic }}
                </div>
              </div>
              <div>
                <div class="div"></div>
                <div class="list">
                  {{ teach.education }}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
	<v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum' @pagechange="pagechange" style="padding-top: 80px;"></v-pagination>
	<footer-nav style="padding-top: 80px;"/>
  </div>
</template>
<script>
import {queryTeacherList} from '@/api/teacher.js'
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
import pagination from '@/components/common/pagination'

export default {
  components: {
    'v-pagination': pagination,
    'header-nav': headerNav,
    'footer-nav': footerNav,
  },
  data() {
    return {
      int: 0,
      pageCount: 1,
      pageSize: 15,
      pageNum: 1,
      teachers: [],
      queryParams: {
        pageNum: 1,
        pageSize: 9,
		teacherName:null
      },
	  total:0
    };
  },
  created() {
    this.getList();
  },
  filters: {
    jsFormat(describe) {
      //return describe.substring(0, 90);
    }
  },
  methods: {
	toIndex(){
	  	this.$router.push('/');
	},
    actli(int) {
      this.int = int;
    },
	getList(){
		queryTeacherList(this.queryParams).then(res => {
			var list = res.rows;
			this.teachers = [];
			this.teachers = res.rows;
			this.total = res.total;
		})
	},
    pagechange(currentPage) {
      console.log(currentPage);
      this.queryParams.pageNum = currentPage;
      // ajax请求, 向后台发送 currentPage, 来获取对应的数据
      this.getList();
    },
    detail(teach) {
      this.$router.push({path:'/teacher/detail',query:teach});
    }

  },
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .color {
        color: #2961EF !important;
    }
    .ignore {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }

    .paging {
      width: 534px;
      height: 50px;
      background: rgba(112, 112, 112, 0.18);
      border-radius: 37px 37px 37px 37px;
      margin: 35px auto;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 300;
      color: #888888;
      justify-content: space-around;
      text-align: center;
    }
    .paging div {
      height: 50px;
      line-height: 50px;
      border-right: 1px solid rgba(112, 112, 112, 0.2);
      width: 20%;
    }
    .paging div:nth-child(5) {
      border: none;
    }

    // 搜索
    .nav {
        background: #f7f8fa;
        width: 100%;
        height: 177px;
        .top {
            display: block;
            font-size: 16px;
            font-weight: 300;
            color: #777777;
            padding: 19px 0 24px;
            .infor {
                color: #2961EF;
            }
        }
        .newbox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .newtop {
                font-size: 26px;
                color: #000000;
                margin-bottom: 5px;
            }
            .newbot {
                font-size: 16px;
                color: #888888;
            }
            .input {
                width: 497px;
                height: 59px;
                background: #ffffff;
                box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
                border-radius: 30px;
                position: relative;
                input {
                    border: none;
                    position: absolute;
                    left: 30px;
                    top: 0;
                    height: 59px;
                    line-height: 59px;
                    width: 365px;
                    font-size: 16px;
                    font-weight: 300;
                    color: #777777;
                }
                .select {
                    position: absolute;
                    right: 12px;
                    top: 8px;
                    width: 74px;
                    height: 43px;
                    line-height: 43px;
                    background: #2961EF;
                    border-radius: 30px;
                    font-size: 16px;
                    font-weight: 300;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }
    }
    // 学科分类
    .bacground {
        background: #f7f8fa;
    }
    .type {
        margin: 27px 0 30px;
        padding: 14px 17px;

        border-radius: 5px 5px 0px 0px;
        border: 1px solid #e3e8f2;
        .ul {
            font-size: 16px;
            color: #333333;
            display: inline-block;
            vertical-align: text-top;
            width: 7%;
            margin-top: 3px;
        }
        ul {
            display: inline-block;
            vertical-align: text-top;
            // float: right;
            width: 93%;
            li {
                display: inline-block;
                font-size: 16px;
                color: #888888;
                margin-right: 30px;
                line-height: 30px;
            }
        }
    }
    // 优秀讲师

    .teacher {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .box {
            position: relative;
            width: 32%;
            margin-bottom: 31px;
            .teachhead {
                position: absolute;
                top: 0;
                left: 10px;
                display: inline-block;
                width: 110px;
                height: 110px;
                box-shadow: 0px 7px 10px 1px rgba(41, 97, 239, 0.2);
                opacity: 1;
                border: 1px solid #2961EF;
                border-radius: 50%;
                span{
                    width: 110px;
                    height: 110px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                }
                img {
                    width: 100%;
                    height: auto;
                    display: inline-block;

                }
            }
            .teachright {
                display: inline-block;
                .namebox {
                    width:280px;
                    height: 40px;
                    line-height: 40px;
                    margin-left: 150px;
                    margin-top: 23px;
                    margin-bottom: 5px;
                    overflow: hidden;

                    .name {
                        font-size: 17px;
                        color: #333333;
                        margin-right: 16px;
                    }
                    .detal {
                        font-size: 12px;
                        color: #777;
                    }
                }

                .listbox {
                    background: #f7f8fa;
                    border-radius: 40px 0px 40px 0px;
                    width: 250px;
                    padding: 15px 15px 15px 150px;
                    .div {
                        display: inline-block;
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        border: 1px solid #2961EF;
                        margin-right: 10px;
                        vertical-align: middle;
                    }
                    .list {
                        vertical-align: middle;
                        display: inline-block;
                        font-size: 14px;
                        line-height: 30px;
                        color: #333333;

                        // &::before {
                        //     content: '';
                        //     width: 10px;
                        //     height: 10px;
                        //     border-radius: 50%;
                        //     border: 3px solid #fa964f;
                        //     margin-right: 15px;
                        // }
                    }
                }
            }
        }
    }
    .wd_cont{
        width: 800px;
        height: 400px;
        display: block;
        margin: 0 auto;
        img{
            width: 120px;
            height: auto;
            display: block;
            margin: 100px auto 0 auto;
            opacity: 0.5;
        }
        p{
            width: 100%;
            height: auto;
            line-height: 80px;
            font-size: 24px;
            font-weight: bold;
            color: #999;
            text-align: center;
            opacity: 0.7;
        }
    }
</style>
